<template>
  <div class="order-elec-visa">
    <div class="elec_visa_wrap">
      <div class="title">
        <div class="desc-wrapper">
          <div class="desc">{{visaFormMap[order.visa_form]}}证</div>
          <div class="warning">{{warningText}}</div>
        </div>
        <a v-if="order.elec_visa_zip_url" class="right primary" @click="downloadElecVisaBatch" >批量下载</a>
        <a href="javascript:void(0)" class="right primary" @click="sendEmailDialog = true">发送至邮箱</a>
      </div>
      <div class="content">
        <div class="people" v-for="item in order.applicant.filter(e => e && e.elec_visa)" :key="item.order_applicant_id">
          <div class="left">{{item.applicant_name}}</div>
          <div class="download-nav">
            <a v-if="item.elec_invoice_url" class="nav-visa" :href="item.elec_invoice_url" download>使馆收据</a>
            <a @click="downloadApplicantElecVisa(item)" class="nav-visa" >下载{{visaFormMap[order.visa_form]}}</a>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="" size="tiny" v-model="sendEmailDialog" :show-close="false" @close="closeEmailModal" custom-class="send-mail-dialog" top="50%">
      <div class="dialog-header" slot="title">
        <div class="title">发送至邮箱</div>
        <div class="header-close" @click="closeEmailModal">
          <i class="el-icon-close" />
        </div>
      </div>
      <div class="dialog-content">
        <div class="mail-item">
          <div class="mail-item-label">邮箱地址</div>
          <div class="mail-item-content">
            <el-input class="email-input" placeholder="请输入邮箱地址" v-model="email" ></el-input>
          </div>
        </div>
      </div>
      <div class="mail-footer">
        <div class="tips">请留意来自service@666visa.cn的邮件</div>
        <el-button type="primary" size="large" class="mail-dialog-btn" @click="$emit('sendEmailEvent', email)">发送</el-button>
      </div>

    </el-dialog>

    <el-dialog title="批量下载" size="tiny" v-model="downLoadDialog">
      <div class="down-all_container">
        <a :href="item.href" target="_blank" v-for="item in down_arr" :key="item.key" class="down-single" :class="{'disabled' : !item.href}">{{item.tip}}</a>
       </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from '../../libs/http';
import { visaFormMap } from '../../constants/product-constants';

export default {
  props: ['order'],
  data() {
    return {
      visaFormMap,
      DM: {},
      sendEmailDialog: false,
      downLoadDialog: false,
      email: '',
      emailLoading: false,
      down_arr: [{
        tip: '批量下载电子签+收据',
        key: 0,
      }, {
        tip: '批量下载电子签',
        key: 1,
      }, {
        tip: '批量下载收据',
        key: 2,
      }],
    };
  },
  watch: {
    sendEmailDialog(n) {
      if (!n) {
        this.email = '';
      }
    },
  },
  computed: {
    warningText() {
      const { visa_type, visa_form } = this.order;
      const visa = {
        入台证: '入台证暂不提供邮寄服务，请下载后，务必彩色打印并与台湾通行证一同携带过关！',
        入金证: '温馨提示：入金证暂不提供邮寄服务，请下载后，务必彩色打印并与台湾通行证一同携带过关！',
        空: `温馨提示：${visaFormMap[visa_form]}暂不提供邮寄服务，请下载后自行打印（黑白与彩色打印皆可），与护照一同携带过关`,
      };
      return visa[visa_type] ? visa[visa_type] : visa['空'];
    },
  },
  created() {},
  methods: {
    // 关闭
    closeEmailModal() {
      this.email = '';
      this.sendEmailDialog = false;
      this.emailLoading = false;
    },
    oepndownLoad() {
      this.down_arr = [{
        tip: '批量下载电子签+收据',
        href: this.order.elec_visa_invoice_zip_url,
        key: 0,
      }, {
        tip: '批量下载电子签',
        href: this.order.elec_visa_zip_url,
        key: 1,
      }, {
        tip: '批量下载收据',
        href: this.order.elec_invoice_zip_url,
        key: 2,
      }];

      this.downLoadDialog = true;
    },
    // 批量下载电子签证
    downloadElecVisaBatch() {
      // 下载最新的
      const loadingIns = this.$loading({
        text: '下载中',
      });
      return Http.post('/order_query', { user_order_id: this.order.user_order_id }).then((data) => {
        loadingIns.close();
        window.open(data.elec_visa_zip_url);
      }).catch(() => {
        loadingIns.close();
      });
    },
    // 下载申请人电子签
    downloadApplicantElecVisa(applicant) {
      const loadingIns = this.$loading({
        text: '下载中',
      });
      Http.post('/applicant_elec_visa_download', {
        order_id: this.order.user_order_id,
        applicant_id: applicant.order_applicant_id,
      }).then((res) => {
        window.open(res.url);
        loadingIns.close();
      }).catch(() => {
        loadingIns.close();
      });
    },
  },
};
</script>
<style lang="less">
.send-email-container {
  width: 80%;
  margin: auto;
  padding: 20px;
}


.down-all_container {
  text-align: center;
  .down-single {
    margin: 0 auto 10px;
    font-size: 14px;
    padding: 6px 0;
    width: 160px;
    border: 1px solid #5e9be1;
    color : #5e9be1;
    border-radius: 4px;
    display: block;
    cursor: pointer;
    &:last-of-type {
      margin-bottom: 0px;
    }
    &:hover {
      background: #5e9be1;
      color: #fff;
    }
    &.disabled {
      pointer-events: none;
      cursor: move;
      background: #ccc;
      color: #fff;
      border-color: #ccc;
    }
  }
}

.send-email-btn {
  margin-top: 20px;
  .el-button {
    width: 100% !important;
  }
}
</style>

<style lang="less" scoped>
@import '../../assets/less/variable.less';
.elec_visa_wrap {
  overflow: hidden;
  margin-bottom: 15px;
  .title {
    height: 82px;
    background-color: #fbfbfb;
    .down_all {
      cursor: pointer;
    }
    .desc-wrapper {
      float: left;
      margin-left: 20px;
    }
    .desc {
      margin-top: 24px;
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }
    .warning {
      margin-top: 11px;
      font-size: 12px;
      color: #ff5a60;
    }
  }
  .content {
    background-color: #fff;
    margin-bottom: 3px;
    .people {
      height: 60px;
      line-height: 60px;
      margin: 0 40px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .download-nav {
        display: flex;
        font-size: 14px;
        align-items: center;
        .nav-receipt {
          margin-right: 40px;
          color: #5e9be1;
        }
        .nav-visa {
          margin: 0px;
          background-color: #5e9be1;
          color: #fff;
          padding: 0 12px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          border-radius: 4px;
          margin-left: 40px;
        }
      }
    }
    .people:last-child {
      border: none;
    }
  }
  .right {
    float: right;
    margin-right: 40px;
    margin-top: 13px;
    background-color: #5e9be1;
    color: #fff;
    font-size: 14px;
    width: 96px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    border-radius: 4px;
    &.primary {
      margin-top: 24px;
      background-color: #fff;
      color: @blue;
      border: 1px solid @blue;
    }
  }
}
.order-elec-visa{
  /deep/ .send-mail-dialog{
    width: 600px;
    transform: translate(-50%, -50%);
    .el-dialog__header{
      padding: 0;
      .dialog-header{
        height: 60px;
        padding: 0 24px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #E9EEF2;
        .title{
          flex-grow: 1;
          font-size: 20px;
          color: #2F333D;
          font-weight: 600;
        }
        .header-close{
          color: #91999F;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
    .el-dialog__body{
      padding: 0px;
      .dialog-content{
        padding: 24px;
        .mail-item{
          display: flex;
          align-items: center;
          margin-bottom: 24px;
          &:last-child{
            margin-bottom: 0;
          }
          &.identity{
            .mail-item-label{
              align-self: flex-start;
              line-height: 40px;
            }
          }
          .mail-item-label{
            width: 74px;
            flex-grow: 0;
            font-size: 16px;
            color:#2F333D;
            font-weight: 600;
            margin-right: 10px;
            flex-shrink: 0;
          }
          .mail-item-content{
            flex-grow: 1;
            overflow: hidden;
            position: relative;
            color:#2C3344;
            .email-input{
              height: 40px;
              .el-input__inner{
                height: 40px;
              }
            }
          }
        }
      }
      .mail-footer{
        border-top: 1px solid #E9EEF2;
        display: flex;
        align-items: center;
        height: 80px;
        padding: 24px;
        .tips{
          flex-grow: 1;
          color: #91999F;
          font-size: 14px;
        }
        .mail-dialog-btn{
          flex-shrink: 0;
          width: 196px;
          height: 48px;
          border-radius:4px;
          background-color: #599FFF;
          font-size: 18px;
          &.is-disabled{
            background: #BCD8FF;
            border: 1px solid #BCD8FF;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-elec-visa.vue